import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const config = {
	apiKey: 'AIzaSyC3jxZmEClLayVvO26T15mWwYHyLf8W4XY',
	authDomain: 'gnarly-goats-5b489.firebaseapp.com',
	databaseURL: 'https://gnarly-goats-5b489-default-rtdb.firebaseio.com',
	projectId: 'gnarly-goats-5b489',
	storageBucket: 'gnarly-goats-5b489.appspot.com',
	messagingSenderId: '856012326516',
	appId: '1:856012326516:web:ba0ac12bc5a14bb46c3321',
	measurementId: 'G-0RZDY8Q9BP',
}

// Initialize Firebase
const app = initializeApp(config)

const analytics = getAnalytics(app)

const appCheck = initializeAppCheck(app, {
	provider: new ReCaptchaV3Provider(
		`${process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY}`
	),
	isTokenAutoRefreshEnabled: true,
})

const auth = getAuth(app)

const functions = getFunctions(app)

console.log(app)
console.log(analytics)
console.log(appCheck)
console.log(auth)
console.log(functions)

// connect to local firebase functions emulator for development testing
// connectFunctionsEmulator(functions, 'localhost', 5001)

export { functions }
